import { Injectable }             from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
}                                 from '@angular/router';
import { Observable, of, EMPTY }  from 'rxjs';
import { mergeMap, take }         from 'rxjs/operators';
 
import { DataService } from '../services/data/data.service';
import { UserModel } from '../models/user.model';
 
@Injectable({
  providedIn: 'root',
})

export class UsersResolverService implements Resolve<UserModel[]> {

  constructor(private dataService: DataService) {
  }
 
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UserModel[]> | Observable<never> {
    return this.dataService.getUsers().pipe(
        take(1),
        mergeMap(item => {
          if (item) {
            return of(item);
          } else {
              return EMPTY;
          }
        })
      );
  }
}